import {Component, ContentChild, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef} from '@angular/core';

@Component({
  selector: 'fx-treeview',
  templateUrl: './treeview.component.html',
  styleUrls: ['./treeview.component.sass'],
})
export class TreeviewComponent implements OnInit, OnDestroy {
  @ContentChild(TemplateRef, { static: false }) templateRef: TemplateRef<any>;
  @Input() root = false;
  @Input() coinType: string;
  children: any;
  @Input() items = [];
  @Output() expanded = new EventEmitter();
  @Output() slct = new EventEmitter();
  constructor() {}
  ngOnInit(): void {}
  expand(node: any): void {
    if (node.expanded && !node.children.length) {
      this.expanded.emit(node);
    }
    if (node.children.length) {
      node.children.forEach((child) => {
        child.hide = false;
      });
    }
  }

  onExpanded(node: any): void {
    this.expanded.emit(node);
  }

  selectItem(node: any): void {
    this.slct.emit(node);
  }

  onSelectItem(node: any): void {
    this.slct.emit(node);
  }

  ngOnDestroy(): void {
    // this.subscription.unsubscribe();
  }
}
